<template>
  <div class="app" v-if="Object.keys(this.auth).length > 0">
    <Header fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand pl-2" :to="{name: 'pregsContents'}">
        <!--<img class="navbar-brand-full" src="/static/img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">-->
        <!--<img class="navbar-brand-minimized" src="/static/img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">-->
        <span class="navbar-brand-full">게임하기 어드민</span>
        <span class="navbar-brand-minimized icon-wrench"></span>
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none mr-auto">
        <!--<b-nav-item href="/" class="px-3">공지 사항</b-nav-item>-->
        <!--<b-nav-item href="/contents" class="px-3">게임 관리</b-nav-item>-->
        <!--<b-nav-item href="/" class="px-3">정산</b-nav-item>-->
        <!--<b-nav-item :to="{name: 'login'}" class="px-3" v-else>로그인</b-nav-item>-->
      </b-navbar-nav>
      <b-dropdown id="ddown1" :text="this.auth.personName + '님' + '(' +loginType + ')'" class="m-md-2  float-right">
        <b-dropdown-item @click="logout">로그아웃</b-dropdown-item>
      </b-dropdown>
      <!--<b-navbar-nav class="ml-auto">-->
        <!--<b-nav-item class="d-md-down-none">-->
          <!--<i class="icon-bell"></i>-->
          <!--<b-badge pill variant="danger">5</b-badge>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
          <!--<i class="icon-list"></i>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
          <!--<i class="icon-location-pin"></i>-->
        <!--</b-nav-item>-->
      <!--</b-navbar-nav>-->
      <!--<AsideToggler class="d-none d-lg-block" />-->
    </Header>
    <div class="app-body">
      <Sidebar fixed>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </Sidebar>
      <main class="main">
        <!--<Breadcrumb :list="list"/>-->
        <div class="container-fluid h-100" style="overflow: auto">
          <router-view></router-view>
        </div>
      </main>
      <!--<Aside fixed>-->
        <!--&lt;!&ndash;aside&ndash;&gt;-->
        <!--&lt;!&ndash;<DafaultAside/>&ndash;&gt;-->
      <!--</Aside>-->
    </div>
    <Footer>
      <!--<slot>-->
        <!--Copyright © Kakao Games Corp. All rights reserved.-->
        <!--<div class="ml-auto">-->
          <!--본 사이트는 chrome 67버전 이상에 최적화되어 있습니다.-->
        <!--</div>-->
      <!--</slot>-->
    </Footer>
  </div>
</template>
<script>
import { Header, SidebarToggler, AsideToggler, Sidebar, SidebarNav, SidebarFooter, SidebarMinimizer, Breadcrumb, Aside } from '@coreui/vue'
import Footer from '@/components/Footer.vue'
import { MODULE_NAME as AUTH_MODULE, LOGOUT } from '@/store/auth/actions.type'
import { $isInhouseLogin, $showModalWithErrorMsg } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    Header,
    SidebarToggler,
    AsideToggler,
    Sidebar,
    SidebarNav,
    SidebarFooter,
    SidebarMinimizer,
    Breadcrumb,
    Aside,
    Footer
  },
  computed: {
    loginType () {
      if (this.typeText[this.auth.authType] !== undefined) {
        return this.typeText[this.auth.authType]
      } else {
        return '(?)'
      }
    },
    ...mapState(AUTH_MODULE, [
      'auth'
    ])
  },
  mounted () {
    // if (this.isInhouseLogin()) {
    //   this.nav.push(
    //     {
    //       title: true,
    //       name: '게임 관리'
    //     },
    //     {
    //       name: '게임등록/조회',
    //       url: this.$router.resolve({name: 'playGameList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '플친등록/조회',
    //       url: this.$router.resolve({name: 'plusFriendList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: 'OS별목록관리',
    //       url: this.$router.resolve({name: 'playGameOsTypeList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '변경요청심사',
    //       url: this.$router.resolve({name: 'gameReviewChangeRequestList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       title: true,
    //       name: '게임하기'
    //     },
    //     {
    //       name: '전면팝업',
    //       url: this.$router.resolve({name: 'playGameFrontPopupList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '이모티콘',
    //       url: this.$router.resolve({name: 'playGameEmoticonList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '대세게임',
    //       url: this.$router.resolve({name: 'playGameMainstreamList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '확장배너',
    //       url: this.$router.resolve({name: 'playGameBannerList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '스낵게임',
    //       url: this.$router.resolve({name: 'playGameSnackgameList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '추천게임',
    //       url: this.$router.resolve({name: 'playGameRecommendList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '메인 순서 설정',
    //       icon: 'icon-note',
    //       url: this.$router.resolve({name: 'playGameMainSetting'}).href,
    //     },
    //     {
    //       title: true,
    //       name: '사전예약 컨텐츠 관리',
    //       class: '',
    //       wrapper: {
    //         element: '',
    //         attributes: {}
    //       }
    //     },
    //     {
    //       name: '등록/조회',
    //       url: this.$router.resolve({name: 'pregsContents'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       title: true,
    //       name: '사전예약 노출 관리'
    //     },
    //     {
    //       name: '공개리스트 관리',
    //       icon: 'icon-list',
    //       children: [
    //         {
    //           name: '리스트',
    //           url: this.$router.resolve({name: 'showListContents'}).href,
    //           icon: 'icon-note'
    //         },
    //         {
    //           name: '등록',
    //           url: this.$router.resolve({name: 'NotShowingPregList'}).href,
    //           icon: 'icon-note'
    //         }
    //       ]
    //     },
    //     {
    //       name: '사전예약 카드 관리',
    //       icon: 'icon-list',
    //       children: [
    //         {
    //           name: '리스트',
    //           url: this.$router.resolve({name: 'cardListContents'}).href,
    //           icon: 'icon-note'
    //         },
    //         {
    //           name: '등록',
    //           url: this.$router.resolve({name: 'pregCardList'}).href,
    //           icon: 'icon-note'
    //         }
    //       ]
    //     }
    //     )
    //   if (this.auth.accountId === "geena.h" || this.auth.accountId === "catherine.park" || this.auth.accountId === "mix.coffee" || this.auth.accountId === "tommy.k"
    //   || this.auth.accountId === "neo.ku" || this.auth.accountId === "mickey.sim" || this.auth.accountId === "huie.kim") {
    //     this.nav.push({
    //         title: true,
    //         name: '권한'
    //       },
    //       {
    //         name: '메뉴 등록',
    //         url: this.$router.resolve({name: 'menuNew'}).href,
    //         icon: 'icon-note'
    //       },
    //       {
    //         name: '메뉴 전체 리스트',
    //         url: this.$router.resolve({name: 'menuList'}).href,
    //         icon: 'icon-note'
    //       },
    //       {
    //         name: '그룹 리스트',
    //         url: this.$router.resolve({name: 'groupList'}).href,
    //         icon: 'icon-note'
    //       },
    //       {
    //         name: '그룹의 유저 리스트',
    //         url: this.$router.resolve({name: 'groupListWithUserList'}).href,
    //         icon: 'icon-note'
    //       },
    //       {
    //         name: '그룹 등록',
    //         url: this.$router.resolve({name: 'groupNew'}).href,
    //         icon: 'icon-note'
    //       },
    //       {
    //         name: '유저 등록',
    //         url: this.$router.resolve({name: 'userNew'}).href,
    //         icon: 'icon-note'
    //       },
    //       {
    //         name: '캐시 지우기',
    //         url: this.$router.resolve({name: 'cacheEvict'}).href,
    //         icon: 'icon-note'
    //       },
    //       {
    //         name: '배치 히스토리',
    //         url: this.$router.resolve({name: 'batchHistory'}).href,
    //         icon: 'icon-note'
    //       })
    //
    //   }
    // } else {
    //   this.nav.push({
    //       title: true,
    //       name: '게임 관리'
    //     },
    //     {
    //       name: '게임등록/조회',
    //       url: this.$router.resolve({name: 'playGameList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       name: '변경요청심사',
    //       url: this.$router.resolve({name: 'gameReviewChangeRequestList'}).href,
    //       icon: 'icon-note'
    //     },
    //     {
    //       title: true,
    //       name: '사전예약 컨텐츠 관리',
    //       class: '',
    //       wrapper: {
    //         element: '',
    //         attributes: {}
    //       }
    //     },
    //     {
    //       name: '등록/조회',
    //       url: this.$router.resolve({name: 'pregsContents'}).href,
    //       icon: 'icon-note'
    //     })
    // }
    const navList = []
    const navItem = {
      name: '',
      url: '',
      icon: ''
    }
    const menuList = JSON.parse(localStorage.getItem('auth')).menus
    if (menuList !== null) {
      // 원뎁스 메뉴 ( 타이틀 메뉴 )
      for(let i = 0; i < menuList.length; i++) {
        navList.push({
          name: menuList[i].upperMenu.menuName || '',
          url: menuList[i].upperMenu.url || '',
          icon: menuList[i].upperMenu.icon || '',
          title: menuList[i].upperMenu.titleYn || false
        })
        // 두텝스 메뉴 ( 하위 메뉴 )
        for (let j = 0; j < menuList[i].lowerMenuList.length; j++) {
          console.log(menuList[i].lowerMenuList[j])
          navList.push({
            name: menuList[i].lowerMenuList[j].menuName,
            url: menuList[i].lowerMenuList[j].url,
            icon: menuList[i].lowerMenuList[j].icon
          })
        }
      }
      this.nav = navList;
      console.log(navList)
    }
  },
  data () {
    return {
      isInhouseLogin: $isInhouseLogin.bind(this),
      nav: [],
      typeText: {
        'ldap': '내부',
        'biz': '비즈'
      }
    }
  },
  methods: {
    logout () {
      this.$store.dispatch(AUTH_MODULE + LOGOUT)
        .then(() => {
          this.$router.push({name: 'login'})
        })
        .catch($showModalWithErrorMsg.bind(this))
    },
    ...mapMutations('ui', [SHOW_MODAL])
  }
}
</script>
<style>
.sidebar .nav-title {
  font-size: 100%
}
.app-header .navbar-brand {
  width: auto
}
</style>
